<script lang="ts">
    export let href: string;
</script>

<li>
    <a on:click {href} class="relative uppercase">
        <span class="hover-shadow absolute right-0 bottom-[0px] transition text-5xl lg:text-7xl"><slot /></span>
        <span class="relative text-2xl lg:text-5xl"><slot /><i></i></span>
    </a>
</li>

<style>
    li {
        font-family: 'Space Grotesk', sans-serif;
        color: #e5e5e5;
        white-space: nowrap;
    }

    .hover-shadow {
        color: black;
        white-space: nowrap;
        opacity: 0;
        text-shadow:
            -1px 0 oklch(var(--p) / 0.7),
            0 1px oklch(var(--p) / 0.7),
            1px 0 oklch(var(--p) / 0.7),
            0 -1px oklch(var(--p) / 0.7);
        transform: scale3d(100%, 30%, 100%);
    }

    li:hover .hover-shadow,
    li:focus .hover-shadow {
        opacity: 1;
        transform: scale3d(100%, 100%, 100%);
    }
</style>
